import { useDispatch } from '../../../Flux/index.ts'
import { orderWizardActions as wizard } from '../../../Flux/Slice/OrderWizard/OrderWizardSlice.ts'
import type { QuestionAnswer } from '../../../Model/OrderWizard/OrderWizardDraft.ts'

export const useAnswer = (draftId: string) => {
  const dispatch = useDispatch()
  return (answer: QuestionAnswer) => dispatch(wizard.questionAnswered({ draftId, answer }))
}
